// @ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import Mazemap from '@itpi/mazemap';
import OverlayContext from './context/OverlayContext';

interface marker {
    colour?: "MazeBlue"|"MazeGreen"|"MazeOrange"|"MazeRed";
    onClick?: Function|undefined|null;
    location: number|any;
}

const Markers: React.FC<{}> = ({
}) => {
    const [markerObjects, setMarkerObjects] = useState([]);
    const {mapRef, markers} = useContext(OverlayContext);

    useEffect(() => {
        markerObjects.forEach(marker => {
            marker.remove();
        })

        const newMarkers = markers.map(item => {
            if(typeof item.location == 'number') item.location = Mazemap.Util.getPoiLngLat(poi);

            const marker = new Mazemap.MazeMarker({
                color: item.colour ? item.colour : "MazeBlue",
                size: 36,
                noClick: true
            })
            .setLngLat(item.location)
            .addTo(mapRef.current);

            if(item.onClick) {
                marker.on("click", item.onClick);
            }
            
            return marker; 
        });

        setMarkerObjects(newMarkers);
    }, [markers]);

  return null;
};

export default Markers;
